import { SearchIcon } from 'assets/icons';
import { debounce } from 'lodash';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { InputField, SelectField } from 'components/FormFields';
import { useLineCategoryList } from 'hooks';
import { AdvancePayload } from 'types';

interface AdvanceFiltersProps {
  initialValues?: Partial<AdvancePayload>;
  onSubmit?: (payload: AdvancePayload) => void;
}

export function AdvanceFilters({ initialValues, onSubmit }: AdvanceFiltersProps) {
  const { t } = useTranslation(['action', 'payroll']);

  const { control, handleSubmit } = useForm<AdvancePayload>({
    defaultValues: {
      search: '',
      ...initialValues,
    },
  });

  const { data: lineCategoryList, isLoading } = useLineCategoryList();
  const lineCategoryOptions = lineCategoryList.map((x) => ({
    label: x.name,
    value: x.projectCode,
  }));

  const handleFiltersSubmit = (formValues: AdvancePayload) => {
    onSubmit?.(formValues);
  };

  const debounceSearchChange = debounce(handleSubmit(handleFiltersSubmit), 350);

  return (
    <form onSubmit={handleSubmit(handleFiltersSubmit)}>
      <StyledContainer>
        <InputField
          name="search"
          control={control}
          placeholder={t('action:search')}
          prefix={<SearchIcon />}
          onChange={() => debounceSearchChange()}
        />

        <StyledSearchField>
          <SelectField
            name="line"
            placeholder={t('payroll:contract_salary.line_category_placeholder')}
            control={control}
            options={lineCategoryOptions}
            showSearch
            allowClear
            loading={isLoading}
            onChange={handleSubmit(handleFiltersSubmit)}
          />
        </StyledSearchField>
      </StyledContainer>
    </form>
  );
}
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
const StyledSearchField = styled.div`
  width: 200px;
`;
